import { useNavigate } from "react-router-dom";
import { userSlice } from '../state/slices/user';
import { useAppSelector } from './../state/store';
import { useEffect } from "react";

const ProtectedRoute = function({ children }) {
  const idToken = useAppSelector(userSlice.selectors.selectIdToken);
  const navigate = useNavigate();
  useEffect(() => {
    if (!idToken) {
      navigate('/login');
    }
  });
  return (
    <>
      {children}
    </>
  );
};


export default ProtectedRoute;